module.exports = __webpack_public_path__ + "assets/chatbot.9c62ce2a.svg";